<template>
    <div>

        <div class="buttonsHolder mt-3 d-flex" v-if="!alreadyDecided">
            <button class="btn action mr-1" @click="rejectInvite">Reject</button>
            <button class="btn flexGrow1" @click="acceptInvite">Send commissions</button>
        </div>

        <div class="mt-3" v-if="alreadyDecided">
            <div v-if="notification.typeStatus == 401" class="d-flex align-items-center">
                <i class="fas fa-times color-6 fs-large"></i>
                <span class="bold darker">Rejected</span>
            </div>
            <div v-if="notification.typeStatus == 402" class="d-flex align-items-center">
                <i class="fas fa-check color-3 fs-large"></i>
                <span class="bold darker">Commissions Sent</span>
            </div>
        </div>

    </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {peopleMixin} from '@/mixins/people'

export default {
    props:{
        notification: {
            type: Object,
        }
    },
    mixins: [
        peopleMixin
    ],
    computed: {
        alreadyDecided: function () {
            if(this.notification.typeStatus){
                if(this.notification.typeStatus == null){
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        requestAgent: function () {
            return this.agentById(this.notification.metadata.agentId)
        }
    },
    methods: {
        ...mapActions([
            'supplierRejectAgentInvite',
            'getAgentInfo'
        ]),
        rejectInvite: function () {
            this.supplierRejectAgentInvite({
                supplierId: this.notification.metadata.supplierId,
                protocolId: this.notification.metadata.protocolId,
                notificationId: this.notification.id
            }).then(response => {
                if(response.status == 200){
                    this.$emit('markAsRead')
                }
            })
        },
        acceptInvite: function () {
            // this.$emit('markAsRead') will be marked as read when accept is done
            this.$router.push({
                name: 'pluralo.agent.accept',
                params: {
                    agentId: this.notification.metadata.agentId,
                    supplierId: this.notification.metadata.supplierId,
                    notificationId: this.notification.id
                }
            });

            this.eventHub.$emit('setInvitationCommissions', {
                agentId: this.notification.metadata.agentId,
                supplierId: this.notification.metadata.supplierId,
                notificationId: this.notification.id
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.buttonsHolder{
    max-width: 370px;
}
</style>



// WEBPACK FOOTER //
// bodyAcceptInvite.vue?3d80b0a6